function initSlickSlider(slider) {
    if (!slider.active) {
        const $sliderElement = $(slider.selector),
            arrowClass = slider.arrowClass || '';

        const defaults = {
            settings: {
                nextArrow: `
                    <button type="button" class="${arrowClass} is-next">
                        <i class="ico ico-arrow-right"></i>
                    </button>
                `,
                prevArrow: `
                    <button type="button" class="${arrowClass} is-prev">
                        <i class="ico ico-arrow-left"></i>
                    </button>
                `,
            },
            callbacks: {
                init: function() {
                    bLazy.revalidate();
                },
                beforeChange: function(event, slick, currentSlide, nextSlide) {
                    fixSlickOverflow(slick, true);
                },
                afterChange: function(event, slick, currentSlide) {
                    bLazy.revalidate();
                    fixSlickOverflow(slick);
                },
                setPosition: function(event, slick) {
                    fixSlickOverflow(slick);
                }
            }
        };

        if (!slider.callbacks) {
            slider.callbacks = {};
        }

        $.each(Object.assign(defaults.callbacks, slider.callbacks), function(callbackName, callbackFunction) {
            $sliderElement.on(callbackName, callbackFunction);
        });

        $sliderElement.slick(Object.assign(defaults.settings, slider.settings));

        slider.active = true;
    }
}

function destroySlickSlider(slider) {
    if (slider.active) {
        $(slider.selector).slick('unslick');

        slider.active = false;
    }
}

function fixSlickOverflow(slick, beforeChange) {
    let $slider = slick.$slider,
        $fixedSlides = $slider.find('.slick-slide[data-old-width]');

    $fixedSlides.each(function() {
        let $this = $(this);

        $this.width($this.attr('data-old-width'));
        $this.removeAttr('data-old-width');
    });

    if (beforeChange) {
        setTimeout(function() {
            fixSlickOverflowSlides($slider);
        }, 10);
    } else {
        fixSlickOverflowSlides($slider);
    }
}

function fixSlickOverflowSlides($slider) {
    let $activeSlides = $slider.find('.slick-slide.slick-active'),
        availableWidth = $slider.outerWidth(),
        usedWidth = 0;

    $activeSlides.each(function() {
        usedWidth += $(this).outerWidth(true);
    });

    let overflowingPixels = usedWidth - availableWidth;

    if (overflowingPixels > 0) {
        let $elementToFix = $activeSlides.last(),
            oldWidth = $elementToFix.outerWidth(true),
            newWidth = oldWidth - overflowingPixels;

        $elementToFix.width(newWidth);
        $elementToFix.attr('data-old-width', oldWidth);
    }
}